const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { gql, useQuery } from '@apollo/client';
import { PROPERTY_FIELDS_FRAGMENT } from '../../fragments/SubscriptionFragments';
import { useRetry } from '../../hooks/useRetry';
import { getValue } from '../../utils/common';
import { handleError } from '../../utils/errorHandling';
export const FETCH_EDIT_NEXT_PAYMENT_DATE_PROPERTIES = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"FetchEditNextPaymentDateProperties\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObject\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"StringValue\",\"value\":\"0-69\",\"block\":false}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"PaymentsSubscription\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"defaultProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_payment_method\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"billingDate\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"earliestDueAt\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"subscriptionInvoiceId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"mutable\"}}]}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: _unique([{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "FetchEditNextPaymentDateProperties"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObject"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "StringValue",
            value: "0-69",
            block: false
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "PaymentsSubscription"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "defaultProperties"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "hs_payment_method"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "PropertyFieldsFragment"
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "billingDate"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "earliestDueAt"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "subscriptionInvoiceId"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "mutable"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }].concat(PROPERTY_FIELDS_FRAGMENT.definitions))
});
export function isEditNextPaymentDateQueryValid(data) {
  var _data$crmObject;
  return Boolean((data === null || data === void 0 || (_data$crmObject = data.crmObject) === null || _data$crmObject === void 0 ? void 0 : _data$crmObject.__typename) === 'PaymentsSubscription' && data.crmObject.defaultProperties && data.crmObject.billingDate);
}
export function useEditNextPaymentDateQuery(objectId) {
  const query = useQuery(FETCH_EDIT_NEXT_PAYMENT_DATE_PROPERTIES, {
    variables: {
      objectId
    },
    fetchPolicy: 'network-only'
  });
  const startRetrying = useRetry({
    retry: () => {
      query.refetch().catch(handleError);
    },
    shouldRetry: () => Boolean(!isEditNextPaymentDateQueryValid(query.data) || query.error),
    onFailedAfterRetries: () => {
      throw new Error('useEditNextPaymentDateQuery failed to finish loading after retries');
    }
  });
  if (query.loading) {
    return Object.assign({}, query, {
      data: null
    });
  }
  if (!query.data) {
    return Object.assign({}, query, {
      data: null
    });
  }
  if (!isEditNextPaymentDateQueryValid(query === null || query === void 0 ? void 0 : query.data) || query.error) {
    startRetrying();
    return Object.assign({}, query, {
      data: null
    });
  }
  const {
    crmObject: {
      defaultProperties: {
        hs_payment_method
      },
      billingDate
    }
  } = query.data;
  return Object.assign({}, query, {
    data: {
      paymentMethod: getValue(hs_payment_method) || '',
      earliestDueAt: billingDate.earliestDueAt,
      subscriptionInvoiceId: billingDate.subscriptionInvoiceId,
      mutable: billingDate.mutable
    }
  });
}